<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>Dashboard - Gestão Aldo</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area gestao-aldo" id="dashboard-solar">
        <div class="row">
          <div class="col-md-12 d-flex d-flex-just-beteween">
            <a href="/calculadora-aldo-solar/novo" class="btn-lista">Novo</a>
            <a href="/calculadora-aldo-solar/projetos" class="btn-lista">Lista de Projetos</a>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="wrapper-content border-radius bg-gray-50">
              <div class="row">
                <div class="col-md-12">
                  <h4>Visão Geral</h4>
                </div>
              </div>
              <div class="row d-flex d-flex-just-beteween">
                <div
                  class="border-radius border-darkblue-solid d-flex flex-align-items-center flex-just-cont-center box-chart-general"
                  v-for="(Indicador, index) in ResumoGeral"
                  :key="index"
                >
                  <div class="value">{{Indicador.Value}}</div>
                  <span class="description">{{Indicador.Label}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-6 col-sm-12" style="height:730px;">
            <div class="wrapper-content border-radius bg-gray-50" style="height: 100%;">
              <div class="content-100">
                <h4>Projetos</h4>
              </div>
              <div class="content-100">
                <!--  Projeto Status Evolucao Line  -->
                <EvolucaoProjetosStatus :Anos="Anos" :Status="Status"></EvolucaoProjetosStatus>
              </div>
              <br />
              <div class="content-100">
                <!-- Projeto Status Pie -->
                <ProjetoStatus :Anos="this.Anos" :Meses="this.Meses"></ProjetoStatus>
              </div>
            </div>
          </div>

          <!-- Integradoras -->
          <integradoras :Anos="this.Anos" :Meses="this.Meses"></integradoras>
        </div>
        <br />

        <div class="row">
          <familia-geradores :Anos="Anos"></familia-geradores>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Integradoras from "./Partials/_Gestao_Integradoras.vue";
import ProjetoStatus from "./Partials/_Gestao_ProjetosStatus.vue";
import EvolucaoProjetosStatus from "./Partials/_Gestao_EvolucaoProjetosStatus.vue";
import FamiliaGeradores from "./Partials/_Gestao_FamiliaGeradores.vue";

import axios from "axios";

export default {
  name: "DashManagement",
  components: {
    Integradoras,
    ProjetoStatus,
    EvolucaoProjetosStatus,
    FamiliaGeradores
  },
  async mounted() {
    this.Anos = this.listarAnos();
    const self = this;
    $.ajax({
      url: this.$apiUrl + "Session.svc/getsessions",
      dataType: "json",
      type: "GET",
      xhrFields: { withCredentials: true },
      error: () => {
        swal({
          title: "É necessário estar logado",
          icon: "warning"
        }).then(
          () =>
            (location.href =
              `${self.$SiteUrl}/login?redirectTo=` + location.href)
        );
      },
      success: response => {
        if (response.DadosCliente.TipoUsuario != 2) {
          location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href;
        }
      }
    });

    this.fillGeral();
  },
  methods: {
    fillGeral: function() {
      let self = this;

      axios
        .get(this.$apiUrl + "Projeto.svc/dashboard/gestaoaldo")
        .then(function(response) {
          self.ResumoGeral = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    listarAnos: function(){
      var ano = 2018;
      var anoFinal = new Date().getFullYear();
      var anos = [];
      for(; ano <= anoFinal; ano++){
        anos.push(ano);
      }
      console.log("anos",anos)
      return anos;
    }
  },
  data: () => ({
    Meses: [
      { id: 1, text: "Jan" },
      { id: 2, text: "Fev" },
      { id: 3, text: "Mar" },
      { id: 4, text: "Abr" },
      { id: 5, text: "Mai" },
      { id: 6, text: "Jun" },
      { id: 7, text: "Jul" },
      { id: 8, text: "Ago" },
      { id: 9, text: "Set" },
      { id: 10, text: "Out" },
      { id: 11, text: "Nov" },
      { id: 12, text: "Dez" }
    ],
    Anos: null,
    Status: [
      { text: "Concluído", id: 0 },
      { text: "Negociando", id: 1 },
      { text: "Aguardando", id: 2 },
      { text: "Efetivado", id: 3 }
    ],
    ResumoGeral: null
  })
};
</script>